<script setup lang="ts">
import type { EventModel } from '@/types/models/EventModel'
import { StackLayout, TypographyWithPrefix } from '@rfc/rfc-components-library'
import { type DateProviderType, EProviders } from '@rfc/rfc-components-library/types'
import moment from 'moment'
import { inject } from 'vue'

const { DATETIME_FORMAT } = inject<DateProviderType>(EProviders.DATE, {})

type Props = {
    data: EventModel
}
defineProps<Props>()
</script>

<template>
    <StackLayout class="section-box px-7 py-4" :gap="8" direction="column">
        <StackLayout direction="column">
            <TypographyWithPrefix
                v-if="data?.start_at"
                :prefix="$t('date.start')"
                :label="moment(data?.start_at).format(DATETIME_FORMAT)"
                class="section-text" />
            <TypographyWithPrefix
                v-if="data?.end_at"
                :prefix="$t('date.end')"
                :label="moment(data?.end_at).format(DATETIME_FORMAT)"
                class="section-text" />
        </StackLayout>

        <StackLayout v-if="data?.guntimes?.length" direction="column">
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-title expand-icon="mdi-menu-down">
                        {{ $t('event.detail.informations.guntimes') }}
                    </v-expansion-panel-title>
                    <v-expansion-panel-text v-for="(item, key) in data?.guntimes" :key="key">
                        <TypographyWithPrefix
                            :prefix="item.name"
                            :label="moment(item.start_at).format(DATETIME_FORMAT).toString()" />
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
            <!-- <TypographyWithPrefix
                v-for="(item, key) in eventData?.guntimes"
                :key="key"
                :prefix="item.name"
                :label="moment(item.start_at).format(DATETIME_FORMAT).toString()" /> -->
        </StackLayout>
    </StackLayout>
</template>

<style scoped lang="scss">
.section-box {
    padding: 0.5em;
}

.collapse-item {
    & :deep(.collapse-title) {
        width: 100%;
        place-content: space-between;
        box-shadow: 0px 0px 3px 1px $primary;
        padding: 4px;
    }
    & :deep(.collapse-content) {
        padding: 8px;
    }
}
</style>
